import { render } from "./Home.vue?vue&type=template&id=aca34ffe&scoped=true&bindings={}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=aca34ffe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aca34ffe"

export default script